// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__9Jf_V","footer":"ModalError_footer__3yqdS"};